import { render } from "./ProposalPage.vue?vue&type=template&id=4ceb71d6"
import script from "./ProposalPage.vue?vue&type=script&lang=js"
export * from "./ProposalPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__